import styled from "styled-components";
import SearchIcon from "@mui/icons-material/Search";
import { Control, FieldValues, useForm } from "react-hook-form";
import { IconButton } from "@mui/material";
import DatumSearch from "components/common/search_sort/DatumSearch";
import { videoSearchFieldsGet } from "common/video/video_search";
import SearchSort from "components/common/search_sort/SearchSort";
import { SEARCH_NAMES } from "constant/search";

type VideoSearchFiltersProps = {
  searchHandle: Function;
};

const defaultVals = videoSearchFieldsGet();

const VideoSearchFilters = ({ searchHandle }: VideoSearchFiltersProps) => {
  const { handleSubmit, control } = useForm({
    defaultValues: defaultVals,
  });

  const onSubmit = async (data: any) => {
    console.log(data);
    searchHandle(data);
  };

  return (
    <div>
      <DivSearchOrder>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <DatumSearch
            fieldName={SEARCH_NAMES.DATUM}
            defaultValue={defaultVals[SEARCH_NAMES.DATUM]}
            fieldRangeTypeName={SEARCH_NAMES.DATUM_RANGE_TYPE}
            defaultRangeTypeValue={
              defaultVals[SEARCH_NAMES.DATUM_RANGE_TYPE as any]
            }
            fieldSecondRangeName={SEARCH_NAMES.DATUM_SECOND_RANGE}
            defaultSecondRangeValue={
              defaultVals[SEARCH_NAMES.DATUM_SECOND_RANGE as any]
            }
            control={control as unknown as Control<FieldValues, any>}
          />
          <SearchSort
            control={control}
            sortByName={SEARCH_NAMES.SORT_BY}
            sortOrderName={SEARCH_NAMES.SORT_ORDER}
            sortByDefaultValue={""}
            sortOrderDefaultValue={""}
          />
          <DivSubmit>
            <IconButton type="submit">
              <SearchIcon />
            </IconButton>
          </DivSubmit>
        </Form>
      </DivSearchOrder>
    </div>
  );
};

const DivSearchOrder = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;

  svg {
    cursor: pointer;
  }
  svg:hover {
    opacity: 0.8;
  }
`;

const Form = styled.form`
  &&& {
    display: flex;
  }
`;

const DivSubmit = styled.div`
  margin-left: 1.5rem;
  display: flex;
`;

export default VideoSearchFilters;
